import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaExportarResumen', NominasNominaExportarResumen)

function NominasNominaExportarResumen($q, NominasNomina) {
  this.get = _get

  function _get(idEmpresa, idNomina, config) {
    return $q.all({
      nomina: NominasNomina.get(idEmpresa, idNomina),
    }).then(function ($resolve) {
      let nomina = $resolve.nomina,
        data = [],
        columnas = []

      if (config.separar_impuesto_estatal) {
        nomina.Subtotal_SA -= nomina.impuesto_estatal

        data.push(['Suministro', nomina.Suministro, 'Impuesto estatal', nomina.impuesto_estatal])
        data.push(['Carga social', nomina.Carga_Social, '', ''])
        data.push(['Otros', nomina.otros, '', ''])
        data.push(['Comisión (' + (nomina.Comision_Porcentaje_SA * 100).toFixed(2) + ' %)', nomina.Comision_Importe_SA, '', ''])
        data.push(['Subtotal', nomina.Subtotal_SA, 'Subtotal', nomina.impuesto_estatal])
        data.push(['IVA', nomina.Subtotal_SA * 0.16, 'IVA', nomina.impuesto_estatal * 0.16])
        data.push(['Total', nomina.Subtotal_SA * 1.16, 'Total', nomina.impuesto_estatal * 1.16])
        data.push(['', '', 'Menos ISN Retenido por el cliente', nomina.impuesto_estatal])
        data.push(['', '', '', nomina.impuesto_estatal * 0.16])
        data.push(['', '', '', ''])
        data.push(['', '', '', ''])
        data.push(['Total General', (nomina.Subtotal_SA * 1.16) + (nomina.impuesto_estatal * 0.16), '', ''])

        columnas.push({label: 'Concepto', format: {align: 'right', width: 20}})
        columnas.push({label: 'Importe', format: {type: 'currency', align: 'right', width: 15}})
        columnas.push({label: 'Concepto', format: {align: 'right', width: 20}})
        columnas.push({label: 'Importe', format: {type: 'currency', align: 'right', width: 15}})
      } else {
        data.push(['Suministro', nomina.Suministro])

        if (nomina.id_regimen_fiscal === '2')
          data.push(['Carga social', nomina.Carga_Social])

        if (nomina.id_regimen_fiscal === '2' || idEmpresa === '1358')
          data.push(['Impuesto estatal', nomina.impuesto_estatal])

        if (nomina.id_regimen_fiscal === '2' || idEmpresa === '1358')
          data.push(['Otros', nomina.otros])

        data.push(['Comisión (' + (nomina.Comision_Porcentaje_SA * 100).toFixed(2) + ' %)', nomina.Comision_Importe_SA])
        data.push(['Subtotal', nomina.Subtotal_SA])
        data.push(['IVA', nomina.IVA_SA])
        data.push(['Total', nomina.Total_SA])

        columnas.push({label: 'Concepto', format: {align: 'right', width: 20}})
        columnas.push({label: 'Importe', format: {type: 'currency', align: 'right', width: 15}})
      }

      var datos = [{
        name: 'Resumen',
        details: [
          {label: 'Empresa: ' + nomina.Empresa, cell: 'D1'},
          {label: 'Nómina: ' + nomina.ID_Nomina, cell: 'D2'},
          {label: nomina.Notas, cell: 'D3'},
          {label: 'Moneda: ' + nomina.Moneda, cell: 'D4'},
          {label: 'Fecha: ' + nomina.Fecha.toYMD(), cell: 'I1'},
          {label: 'Fecha de pago: ' + nomina.Fecha_Pago.toYMD(), cell: 'I2'},
        ],
        columns: columnas,
        options: {
          logo: {
            filename: config.logotipo,
            title: 'FAN Consultores',
            cell: 'A1',
          },
          show_grid: false,
          fixed_column: 'A8',
        },
        data: data,
      }]

      if (!config.pueblo_bonito) {
        datos[0].details.push({label: 'Fecha inicial: ' + nomina.Fecha_Inicial.toYMD(), cell: 'I3'})
        datos[0].details.push({label: 'Fecha final: ' + nomina.Fecha_Final.toYMD(), cell: 'I4'})
      }

      return datos
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Exportar/Resumen.js